<template>
    <section>
        <sy-baselist
                ref="main"
                :filters="filters"
                editVue="business/Attendance_Edit.vue"
                listUrl="server/business/Attendance.ashx?cmd=GetRecordList"
                deleteUrl="server/business/Attendance.ashx?cmd=Delete"
                fixOperate
        >
            <el-table-column prop="FDate" label="考勤年月" :formatter="formatDate3" width="100" >
            </el-table-column>
            <el-table-column prop="UserName" label="姓名" width="120" >
            </el-table-column>
             <el-table-column prop="Phone" label="电话" width="200" >
            </el-table-column>
             <el-table-column prop="FDays" label="出勤天数" width="200" >
            </el-table-column>
              <el-table-column prop="FIsFull" label="是否全勤" :formatter="formatIsfull" width="200" >
            </el-table-column>
            <el-table-column prop="note" label="备注" width="120" > 
            </el-table-column>
               <template  slot="extendbtnTop" scope="props">
                 <el-button size="small" style="margin-left: 0px;" @click="showimports">导入数据</el-button>
              </template>
        </sy-baselist>
         <excelimport @onImportSuc="importfinish" ref="excelimport"></excelimport>
    </section>
</template>

<script>
    import util from '../../common/util'
    import excelimport from './Attendance_Import.vue'
    export default {
         components:{
            excelimport
        },
        data(){
            return {
                showtips:false,
                filters: [{type: "string",name:"User.FName",text:"姓名", value: ""},
                       {type: "date",name:"FDate",text:"考勤年月",dateType:'month',remote:true},
                     ],
                
            }
        },
        methods:{
        formatDate3(row, column){
            if (row[column.property]) {
                return util.date.format(row[column.property], "yyyy年MM月")
            } else {
                return ""
            }
        },
       formatIsfull(row){
            return row.FIsFull==0?"否":"是"
       },
        showimports(){
            this.$refs.excelimport._open()
        },
       
        importfinish(){
            this.$refs.main._refrash()
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/Attendance.vue